import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TPostContentPhotoGalleryReset, EPostContentPhotoGalleryActionType } from './types';

export const resetPostContentPhotoGallery: () => TPostContentPhotoGalleryReset =
  actionGenerator<EPostContentPhotoGalleryActionType.Reset>(EPostContentPhotoGalleryActionType.Reset);
